/* Layout */
import Layout from '../../views/layout/Layout.vue'

const PrivateClientDetail = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/detail')
const PrivateClientList = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/list')
const PrivateClientAddressDetail = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/address-detail')
const PrivateClientProfileDetail = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/profile-detail')
const PrivateClientOrderDetail = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/order-detail')
const PrivateClientOrderList = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/order-list')
const PrivateClientOrderRefundRequestList = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/order-refund-request-list')
const PrivateClientReport = () => import(/* webpackChunkName: "private-client" */ '@/views/private-client/report')

export default [
  {
    path: '/private-client',
    component: Layout,
    redirect: '/private-client/order/list',
    name: 'Private Client',
    alwaysShow: true,
    meta: {
      title: 'privateClient',
      icon: ['fas', 'user-secret'],
    },
    children: [
      {
        path: 'client/create',
        component: PrivateClientDetail,
        name: 'PrivateClientCreate',
        hidden: true,
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/edit/:id',
        component: PrivateClientDetail,
        props: true,
        name: 'PrivateClientEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/list',
        component: PrivateClientList,
        name: 'ClientList',
        meta: {
          title: 'Client List',
          icon: 'list',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/:privateClientId/address/create',
        component: PrivateClientAddressDetail,
        name: 'PrivateClientAddressCreate',
        hidden: true,
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/:privateClientId/address/edit/:id',
        component: PrivateClientAddressDetail,
        props: true,
        name: 'PrivateClientAddressEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/:privateClientId/profile/create',
        component: PrivateClientProfileDetail,
        name: 'PrivateClientProfileCreate',
        hidden: true,
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'client/:privateClientId/profile/edit/:id',
        component: PrivateClientProfileDetail,
        props: true,
        name: 'PrivateClientProfileEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'order/create',
        component: PrivateClientOrderDetail,
        name: 'OrderCreate',
        hidden: true,
        meta: {
          title: 'Order Create',
          icon: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'order/edit/:id',
        component: PrivateClientOrderDetail,
        name: 'OrderEdit',
        props: true,
        hidden: true,
        meta: {
          title: 'Order Edit',
          icon: 'edit',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'order/list',
        component: PrivateClientOrderList,
        name: 'OrderList',
        meta: {
          title: 'Order List',
          icon: 'list',
          accessibleName: 'private-client',
        },
      },
      {
        path: 'order/refund-request/list',
        component: PrivateClientOrderRefundRequestList,
        name: 'OrderRefundRequestList',
        meta: {
          title: 'Order Refund Request List',
          icon: 'list',
          accessibleName: 'private-client-refund',
        },
      },
      {
        path: 'report',
        component: PrivateClientReport,
        name: 'Report',
        meta: {
          title: 'Report',
          icon: 'list',
          accessibleName: 'private-client-report',
        },
      },
    ],
  },
]
